import {createSelector} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {IDayNotesState} from '@app/core/store/state/daynotes.state';

const _selectDayNotes = (state: IAppState) => state.dayNotes;

export const selectDayNotes = createSelector(
	_selectDayNotes,
	(state: IDayNotesState) => state.dayNotes,
);
export const selectSelectedDayNote = createSelector(
	_selectDayNotes,
	(state: IDayNotesState) => state.selectedDayNote,
);
export const selectSelectedDate = createSelector(
	_selectDayNotes,
	(state: IDayNotesState) => state.selectedDate,
);
export const selectIsLoadingDayNotes = createSelector(
	_selectDayNotes,
	(state: IDayNotesState) => state.isLoading,
);

